module.exports = function() {
  return new Worker(__webpack_public_path__ + "d32f04ad7ce3cae65d70.worker.js");
};